// src/components/AboutMe.js
import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useText } from '../context/TextContext';

const AboutMe = () => {
  const textData = useText();

  return (
    <Box id="about-me" sx={{ padding: 4, backgroundColor: '#FFFFFF', border: '1px solid #EDEBE9', borderRadius: 1, my: 2 }}>
      <Container disableGutters>
        <Typography variant="h4" gutterBottom sx={{ color: '#0078D4' }}>About Me</Typography>
        <Typography variant="body1" paragraph>
          {textData.aboutMe}
        </Typography>
        <Typography variant="body1" paragraph>
          I have extensive experience in system design architecture, leadership, and mentoring. I have led a team of 12
          in a large-scale scrum programme of 400+ people, managing complex initiatives and ensuring successful delivery.
          Through Aldea Systems I look for B2B vendor collaboration on cloud and data engineering for connected products.
        </Typography>
        {textData.openTo && (
          <Typography variant="body1" sx={{ color: '#605E5C' }}>
            {textData.openTo}
          </Typography>
        )}
      </Container>
    </Box>
  );
};

export default AboutMe;
